export const ExpressionUtils = {
    highlightTokenClass:     'highlight-token',
    pleaseChooseTokenClass:  'please-choose-token',
    pleaseChooseSensorClass: 'please-choose-sensor',
    dayOfWeek:               'dayofweek',
    hourOfDay:               'hourofday',
    timeOfDay:               'timeofday'
};

export const funcMeta = {
    'functionTypes': [
        {
            'category':  'Commonly Used',
            'functions': [
                {
                    'name':       '(n)',
                    'function':   '(n)',
                    'argsLength': '1'
                },
                {
                    'name':       'Ceiling (n)',
                    'function':   'Math.ceil(n)',
                    'argsLength': '1'
                },
                {
                    'name':       'Floor (n)',
                    'function':   'Math.floor(n)',
                    'argsLength': '1'
                },
                {
                    'name':       'Round (n)',
                    'function':   'Math.round(n)',
                    'argsLength': '1'
                },
                {
                    'name':       'ABS (n)',
                    'function':   'Math.abs(n)',
                    'argsLength': '1'
                },
                /*
                {
                    'name':       'DayOfWeek',
                    'function':   'DayOfWeek',
                    'argsLength': '1'
                },
                {
                    'name':       'HourOfDay',
                    'function':   'DayOfWeek',
                    'argsLength': '1'
                },
                {
                    'name':       'TimeOfDay',
                    'function':   'DayOfWeek',
                    'argsLength': '1'
                },
                */
                {
                    'name':       'Max',
                    'function':   'Math.max',
                    'argsLength': 'n'
                },
                {
                    'name':       'Min',
                    'function':   'Math.min',
                    'argsLength': 'n'
                },
                // {
                //     'name':       'Sum',
                //     'function':   'Math.sum',
                //     'argsLength': 'n'
                // },
                // {
                //     'name':       'Avg',
                //     'function':   'Math.avg',
                //     'argsLength': 'n'
                // },
                {
                    'name':       'Sqrt (n)',
                    'function':   'Math.sqrt(n)',
                    'argsLength': '1'
                }

            ]
        }
    ]
};
